import { useAlert } from '@/contexts/AlertContext';
import { useMarketHoursAlert } from '@/hooks/useMarketHoursAlert';
import React from 'react';
import AlertPortal from '../AlertPortal/AlertPortal';
import { BannerAlert } from '../BannerAlert';
import { Alert } from '@/types/alert';

import styles from './AlertContainer.module.css'


interface AlertContainerProps {
    maxAlerts?: number;
    enableMarketHoursAlerts?: boolean;
    weekendMessage?: string;
    marketCloseMessage?: string;
    timezone?: string;
}

const AlertContainer: React.FC<AlertContainerProps> = ({
    maxAlerts = 5,
    enableMarketHoursAlerts = true,
    weekendMessage,
    marketCloseMessage
}) => {
    const { alerts, hideAlert } = useAlert();

    useMarketHoursAlert({
        enabled: enableMarketHoursAlerts,
        weekendMessage,
        marketCloseMessage,
    });

    if (alerts.length === 0) return null;

    const visibleAlerts = alerts.slice(0, maxAlerts);

    const handleDismiss = (id: string | number): void => {
        hideAlert(id);
    };


    return (
        <AlertPortal>
            {visibleAlerts.length && (
                <div className={styles.alertContainer}>
                    {visibleAlerts.map((alert: Alert) => (
                        <BannerAlert
                            key={alert.id}
                            alert={alert}
                            onDismiss={handleDismiss}
                        />
                    ))}
                </div>
            )}
        </AlertPortal>
    );
};

export default AlertContainer;